import { render, staticRenderFns } from "./create-product.vue?vue&type=template&id=3ada6b33&scoped=true&"
import script from "./create-product.ts?vue&type=script&lang=ts&"
export * from "./create-product.ts?vue&type=script&lang=ts&"
import style0 from "./create-product.scss?vue&type=style&index=0&id=3ada6b33&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ada6b33",
  null
  
)

export default component.exports